import { createFileRoute } from '@tanstack/react-router'

import { TermsTemplatesPage } from '@/pages/settings/terms-templates/TermsTemplatesPage'

export const Route = createFileRoute(
  '/_authenticated/_dashboard/settings/terms-templates/',
)({
  component: TermsTemplatesPage,
})
